/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

window.Vue = require('vue')
import VueSimpleSVG from 'vue-simple-svg'
import { getQueryParamMixin } from './mixins/getQueryParamMixin'
import { getSvgFilePathMixin } from './mixins/getSvgFilePathMixin'
import store from './store'

window.Vue.use(VueSimpleSVG)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 * Exclude the BibleCloud components, as they have their own app entry point
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /^(?:(?!biblecloud\/components).)*\.vue$/i)
files.keys().map(key =>
    window.Vue.component(
        key
            .split('/')
            .pop()
            .split('.')[0],
        files(key).default
    )
)

/* A Mixin for global funtions */

window.Vue.mixin(getQueryParamMixin)
window.Vue.mixin(getSvgFilePathMixin)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new window.Vue({
    el: '#app',
    store,
})

// force embedded iframe to update its size when window size is changed
window.addEventListener("resize", function() {
    // stop any previous sermonCloudResizeHeight loops while the browser is changing sizes
    clearTimeout(window.sermCloudResizeTimeout)
    window.sermonCloudResizeHeight()
})
// keep track of the number of times we're re-requesting sermonCloudResizeHeight()
window.sermonCloudResizeHeightIntervalCount = 0;

// resize the embedded iframe so it is the same height as all of its content
window.sermonCloudResizeHeight = function(delay) {
    delay = delay || 150;
    window.sermonCloudResizeHeightIntervalCount++;
    window.sermCloudResizeTimeout = setTimeout(() => {
        const height = document.body.offsetHeight
        window.parent.postMessage(['setHeight', height], '*')

        // re-request the sermonCloudResizeHeight 5 times with a 1 second delay
        // to ensure are accounting for heights of slowly loading image and content
        if (window.sermonCloudResizeHeightIntervalCount <= 5) {
            window.sermonCloudResizeHeight(1000);
        } else {
            window.sermonCloudResizeHeightIntervalCount = 0;
        }
    }, delay)
}
